import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Home as HomeIcon } from 'lucide-react';
import { Button } from '../components/ui/button';
import Seo from '../components/Seo';

const NotFound = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" style={{ backgroundColor: '#F9F6F0' }}>
      <Seo
        title="Page non trouvée | Espace Agenda"
        noindex
        description="La page que vous recherchez n'existe pas ou a été déplacée."
      />
      <div className="text-center max-w-lg py-24" data-testid="not-found-page">
        <p className="font-heading font-medium mb-4" style={{ fontSize: 'clamp(3.5rem, 10vw, 6rem)', color: '#5A7161', lineHeight: 1 }}>
          404
        </p>
        <h1 className="font-heading font-medium text-3xl sm:text-4xl mb-4" style={{ color: '#2C352D' }}>
          Cette page n'existe pas
        </h1>
        <p className="text-base leading-relaxed mb-10" style={{ color: '#5E6C60' }}>
          Le lien que vous avez suivi est peut-être obsolète, ou l'adresse a été mal saisie. Retournez à l'accueil ou explorez nos offres.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button
              size="lg"
              className="rounded-full text-white font-medium px-8"
              style={{ backgroundColor: '#5A7161' }}
              data-testid="not-found-home-button"
            >
              <HomeIcon className="mr-2 h-4 w-4" />
              Retour à l'accueil
            </Button>
          </Link>
          <Link to="/offres">
            <Button
              size="lg"
              variant="outline"
              className="rounded-full px-8 font-medium"
              style={{ borderColor: '#5A7161', color: '#5A7161', borderWidth: '2px' }}
              data-testid="not-found-offres-button"
            >
              Voir les offres
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
